export default __webpack_public_path__ + "static/media/img-0261-saudi-arabia-full-face.b65d2b99.png";